export default "__VITE_ASSET__CbT4U2V7__"